import styled, { createGlobalStyle } from 'styled-components';
import { theme } from '../theme';

export const GlobalStyle = createGlobalStyle`
  *, *::before, *::after { box-sizing: border-box; }
  html, body, #root {
    min-height: 100vh;
    margin: 0;
    width: 100%;
    max-width: 100%;
  }
  html { overflow-x: hidden; }
  body {
    font-family: ${theme.fonts.body};
    background: radial-gradient(circle at 20% 20%, rgba(157, 78, 221, 0.15), transparent 40%),
                radial-gradient(circle at 80% 0%, rgba(76, 201, 240, 0.12), transparent 35%),
                ${theme.colors.bgPrimary};
    color: ${theme.colors.text};
  }
  a { color: ${theme.colors.pink}; text-decoration: none; }
  input, select, textarea, button { font-family: inherit; }
`;

export const Page = styled.div`
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 1.5rem 1rem;

  @media (max-width: 480px) {
    padding: 1.15rem 0.85rem;
  }
`;

export const Title = styled.h1`
  font-family: ${theme.fonts.heading};
  font-size: clamp(1.6rem, 4vw, 2.2rem);
  color: ${theme.colors.pink};
  text-shadow: ${theme.colors.glow};
  margin: 0 0 1rem;
`;

export const Card = styled.div`
  background: ${theme.colors.bgCard};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.radius};
  padding: 1.25rem;
  backdrop-filter: blur(8px);
  min-width: 0;

  @media (max-width: 480px) {
    padding: 1rem;
  }
`;

export const Button = styled.button<{ $variant?: 'primary' | 'ghost' | 'danger' }>`
  border: none;
  border-radius: 8px;
  padding: 0.65rem 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease;
  background: ${({ $variant }) =>
    $variant === 'ghost' ? 'transparent' :
    $variant === 'danger' ? theme.colors.danger :
    `linear-gradient(135deg, ${theme.colors.pink}, ${theme.colors.purple})`};
  color: ${({ $variant }) => ($variant === 'ghost' ? theme.colors.textMuted : '#fff')};
  border: ${({ $variant }) => ($variant === 'ghost' ? `1px solid ${theme.colors.border}` : 'none')};
  &:hover { transform: translateY(-1px); box-shadow: ${theme.colors.glow}; }

  @media (max-width: 480px) {
    min-height: 44px;
    padding: 0.7rem 1rem;
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 0.65rem 0.85rem;
  border-radius: 8px;
  border: 1px solid ${theme.colors.border};
  background: ${theme.colors.bgSecondary};
  color: ${theme.colors.text};
`;

export const Grid = styled.div<{ $cols?: number }>`
  display: grid;
  grid-template-columns: repeat(${({ $cols }) => $cols || 1}, minmax(0, 1fr));
  gap: 1rem;
  width: 100%;

  @media (max-width: 900px) {
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 240px), 1fr));
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const Label = styled.label`
  display: block;
  font-size: 0.85rem;
  color: ${theme.colors.textMuted};
  margin-bottom: 0.35rem;
`;

export const FormRow = styled.div` margin-bottom: 0.85rem; `;

export const ErrorText = styled.p`
  color: ${theme.colors.danger};
  font-size: 0.85rem;
`;

export const Muted = styled.p`
  color: ${theme.colors.textMuted};
  line-height: 1.6;
`;
